var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreennode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.665039 7.3099H5.33171M5.33171 7.3099C5.33171 6.69106 5.57754 6.09756 6.01512 5.65998C6.45271 5.22239 7.0462 4.97656 7.66504 4.97656C8.28388 4.97656 8.87737 5.22239 9.31495 5.65998C9.75254 6.09756 9.99837 6.69106 9.99837 7.3099M5.33171 7.3099C5.33171 7.92873 5.57754 8.52223 6.01512 8.95981C6.45271 9.3974 7.0462 9.64323 7.66504 9.64323C8.28388 9.64323 8.87737 9.3974 9.31495 8.95981C9.75254 8.52223 9.99837 7.92873 9.99837 7.3099M9.99837 7.3099H14.665",
    stroke: "#009689",
    strokeWidth: 1.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreennode);
export default __webpack_public_path__ + "static/media/greennode.01548da0ca68b6900f4af1f0c1ca9410.svg";
export { ForwardRef as ReactComponent };